import { LollipopState, ChannelEvent } from '../types'

const getInitialState = (): LollipopState => ({ data: [], loading: true })

export const lollipopReducer: WidgetReducerType<LollipopState, FlowMessage<LiveEvent<ChannelEvent>>> = (
    state = getInitialState(),
    message
) => {
    // test for initialState calls
    if (!message) {
        return state
    }

    if (message.baseline && message.type !== 'event') {
        return state
    }

    switch (message?.type) {
        case 'start':
            console.log('start', message)

            return getInitialState()
        case 'span':
            console.log('span', message)

            return state
        case 'event':
            return {
                ...state,
                data: [...state.data, ...message.events]
            }
        case 'endHistory':
            console.log('endHistory', state)

            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}
